export default __webpack_public_path__ + "cadbb5bc76351f5b3a0ec4379b9434e1.mov";